import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-permission-stamp',
  templateUrl: './location-permission-stamp.component.html',
  styleUrls: ['./location-permission-stamp.component.scss'],
})
export class LocationPermissionStampComponent  implements OnInit {
  @Input() mode:'button'
  constructor() { }

  ngOnInit() {}

}
